import jobs from './apis/jobs';
import locations from './apis/locations';
import candidate from './apis/candidate';
import authentication from './apis/authentication';
import lmis from './apis/lmis';
import experimentation from './apis/experimentation';

export default () => {
  return {
    jobs,
    locations,
    candidate,
    authentication,
    experimentation,
    lmis
  };
};



/** WEBPACK FOOTER **
 ** ./app/wip_modules/seek-jobs-api-client/index.js
 **/